import { useEffect, useState } from 'react';
import { proxyGet } from 'api/ManApi';
import Modal from 'components/Modal';
import { getDomainAndPort, getProtocolDomainAndPort } from 'api/Utils';
import i18n from '../../i18n';

export function getAppRastechProxyUrl(url: string) {
  return 'https://app.rastech.ir/man/rest/proxy/get?url=' + url;
}

export function replaceAbsoluteUrls(htmlString: string) {
  const pattern = /src="(https?:\/\/[^"'>\s]+)/g;

  function replaceUrl(match: string) {
    const encodedUrl = encodeURIComponent(match.substring(5));
    const baseUrl = getProtocolDomainAndPort(getDomainAndPort());
    return `src="${baseUrl}/man/rest/proxy/get?url=` + encodedUrl;
  }

  return htmlString.replace(pattern, replaceUrl);
}

interface IGuideModalProps {
  guideLink: string;
  guideTitle: string;
  isOpen: boolean;
  onClose: () => void;
  onOpen?: () => void;
}

const GuideModal: React.FC<IGuideModalProps> = ({
  guideLink,
  guideTitle,
  isOpen,
  onClose,
  onOpen,
}) => {
  const [modalBody, setModalBody] = useState<null | string>(null);
  const [isLoading, setIsLoading] = useState(false);

  const loadGuideDocument = async () => {
    const documentId = guideLink.split('/').at(-1);

    if (!documentId) {
      setModalBody(
        `<p class="modal-error-text">${i18n.t('errorOnFetch', { ns: 'general' }) as string}</p>`
      );
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const url = `https://app.rastech.ir/man/rest/provider/getDocument?providerDocumentId=${documentId}`;
    await proxyGet(url)
      .then(async (res) => {
        const documentUrl = res.data.document.url;
        await proxyGet(documentUrl).then((docRes) => {
          setModalBody(replaceAbsoluteUrls(docRes.data));
        });
      })
      .catch((_) => {
        setModalBody(
          `<p class="modal-error-text">${i18n.t('errorOnFetch', { ns: 'general' }) as string}</p>`
        );
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (isOpen && !modalBody && !isLoading) {
      if (onOpen) {
        onOpen();
      }
      loadGuideDocument();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleClose = () => {
    setModalBody(null);
    setIsLoading(false);
    onClose();
  };

  return (
    <Modal
      title={guideTitle}
      onClose={handleClose}
      isActive={isOpen}
      width="90%"
    >
      {isLoading ? (
        <div className="loading-text animate-pulse">
          <span>{i18n.t('loading', { ns: 'general' }) as string}</span>
        </div>
      ) : (
        <div
          className="ck-view text-black"
          dangerouslySetInnerHTML={{ __html: modalBody || '' }}
        />
      )}
    </Modal>
  );
};

export default GuideModal;
